import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common/index';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/index';
import { useGetErasmusUniversitiesQuery } from '../../../../../redux/services/erasmusUniversities';
import UniversityModal from '../ErasmusUniversities/ErasmusUniversitiesEdit/UniversityModal/UniversityModal';
import { isNull } from 'lodash';
import ErasmusUniversitiesTable from '../ErasmusUniversities/ErasmusUniversitiesTable';
import OpenStreetMap from '../../../../layout/PublicLayout/Components/Map/OpenStreetMap';
import './ErasmusDashboardPage.sass';

const ErasmusDashboard = () => {
  const { t } = useTranslation();
  const [universityInPreviewId, setuniversityInPreviewId] = useState(null);
  const { data: erasmusUniversities, isLoading } =
    useGetErasmusUniversitiesQuery(true);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Mapa univerzít')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock collapsible={true} title={t('Mapa univerzít')}>
          <OpenStreetMap
            style={{
              height: '450px',
              width: '100%',
              marginTop: 0,
            }}
            markerData={erasmusUniversities}
            buttonAction={(record) => setuniversityInPreviewId(record.id)}
          />
        </CollapseBlock>

        <CollapseBlock collapsible={true} title={t('Zoznam univerzít')}>
          <ErasmusUniversitiesTable
            erasmusUniversities={erasmusUniversities}
            onPreviewClick={(record) => setuniversityInPreviewId(record.id)}
            showFilterBlock={false}
          />
        </CollapseBlock>
      </div>
      {!isNull(universityInPreviewId) && (
        <UniversityModal
          visible
          variant="drawer"
          university={erasmusUniversities.find(
            (u) => u.id === universityInPreviewId,
          )}
          id={universityInPreviewId}
          toggleModal={() => setuniversityInPreviewId(null)}
          title={t('Detail univerzity')}
        />
      )}
    </>
  );
};

export default ErasmusDashboard;
